// extracted by mini-css-extract-plugin
export default {"SiteRequirements":"zTAkE8Cwszs2jhLZaRDL","SiteRequirements_grid":"oE5_A_AiO1aWKWP8rCR2"};